import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import { formatMatch2Duration } from '../match2.util';
import createIntervalEmitter from 'src/lib/createIntervalEmitter';
import { Match2ModelTournamentData } from 'src/replicant/match2/tournament/match2-tournament.actions';
import { State } from 'src/replicant/State';
import * as match2TournamentGetters from 'src/replicant/match2/tournament/match2-tournament.getters';
import { user, now } from 'src/StateObserver';

export class Match2TournamentTimer2 extends View {
  private readonly bg: ImageScaleView;
  private readonly text: LangBitmapFontTextView;
  private tournamentData?: Match2ModelTournamentData;

  constructor(opts: ViewOpts) {
    super({ width: 202, height: 52, ...opts });

    this.bg = new ImageScaleView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      image: 'assets/ui/match2/races/common/time_frame.png',
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: { left: 48, right: 24 },
      },
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: 110,
      y: 23,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 24,
      font: 'Body',
      width: 110,
      height: 30,
      color: '#BF8147',
    });

    createIntervalEmitter(({ user }, now) => ({ user, now })).addListener(
      ({ user, now }) => this.update(user, now),
    );
  }

  public setTournamentData(data: Match2ModelTournamentData) {
    this.tournamentData = data;
    this.update(user(), now());
  }

  private update(state: State, now: number) {
    let remainingTime = 0;

    if (!this.tournamentData) {
      remainingTime = match2TournamentGetters.getRemainingTime(state, now);
    } else if (this.tournamentData.finalRank) {
      remainingTime = 0;
    } else {
      remainingTime = this.tournamentData.endDate - now;
    }

    this.text.localeText = () => {
      if (remainingTime <= 0) {
        return i18n('match2.races.finished');
      }
      return formatMatch2Duration(remainingTime, true);
    };
  }
}
